import MessageMediaItemComponent from "./MessageMediaItemComponent";

export default MessageMediaItemComponent;
